import Crud from '../components/Regional/Crud'
import Add from '../components/Regional/Add'
import Edit from '../components/Regional/Edit'

let routes = {
    path: '/regionals',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/regionals/add',
            name: 'Nova Regional',
            component: Add
        },
        {
            path: '/regionals/edit/:id?',
            name: 'Editar Regional',
            component: Edit
        },
        {
            path: '/regionals',
            name: 'Regionais',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/regional.js